import orderingUtils from '@/services/common/ordering.utils.js';
import comparableUtils from '@/services/propertyComparables/comparable.utils';
import ParamListFields from '@/consts/paramListFields.enum.js';

const _paramListKeyAccessor = function (paramListItem) {
  return paramListItem.ValueCode;
};

const _paramListFieldAccessorGenerator = function (field) {
  return (paramListItem) => {
    return paramListItem[field];
  };
};

const orderComparablesByParamList = function (comparables, comparableField, paramList, paramListField = ParamListFields.ValueOrder) {
  return orderingUtils.orderByMappedCategory(comparables, (comparable) => comparableUtils.getFieldValueFromComp(comparable, comparableField, null), paramList, _paramListKeyAccessor, _paramListFieldAccessorGenerator(paramListField));
};

export default {
  orderComparablesByParamList,
  ParamListFields,
};
